<template>
  <div>
    <el-card>
      <!-- 整体卡片头 -->
      <div slot="header">
        <span v-if="date">
          安排
          {{ date.format('yyyy年MM月dd日') }} {{ date.getDay() | week }}
          的生产任务
        </span>
        <el-button
          type="text"
          icon="el-icon-close"
          @click="back"
          style="float: right; color: red; padding: 0; font-size: 28px"
        >
        </el-button>
      </div>

      <!-- 整体卡片体 -->
      <el-form v-model="form" ref="form" size="small" label-position="top">
        <el-row :gutter="20">
          <!-- 第一列：建议 -->
          <el-col :span="7">
            <el-divider>生产建议和备忘</el-divider>
            <p v-for="s in suggest" :key="s">{{ s }}</p>
          </el-col>
          <!-- 第二列：投入品 -->
          <el-col :span="10">
            <el-divider>投入品</el-divider>
            <el-card
              v-for="(ipt, i) in form.inputs"
              :key="i"
              body-style="padding:8px"
              style="margin-bottom: 5px"
            >
              <el-row :gutter="5">
                <el-col :span="12">
                  <el-select v-model="form.inputs[i].id" size="small" @change="getMaxNum(ipt.id,form.inputs,i)">
                    <el-option
                      v-for="ipt in inputsOptions"
                      :key="ipt.id"
                      :value="ipt.id"
                      :label="ipt.name"
                      :disabled="isDisabled(ipt.id)"
                    />
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-input-number
                    :min="0"
                    :max="ipt.maxNum"
                    :precision="1"
                    :step="0.1"
                    size="small"
                    v-model="form.inputs[i].volumn"
                    style="width: 120px"
                  />
                </el-col>
                <el-col :span="4" style="line-height: 30px">
                  {{form.inputs[i].packingForm}}
                  <el-button
                    @click="inputsDelete(i)"
                    type="text"
                    icon="el-icon-close"
                    size="mini"
                    style="
                      color: red;
                      padding: 0;
                      font-size: 18px;
                      float: right;
                      line-height: 30px;
                    "
                  ></el-button>
                </el-col>
              </el-row>

              <!-- <span>投入品:{{ ipt.id | inputsName }}</span>
              <span>用量：{{ ipt.volumn }} {{ ipt.id | inputsPackForm }}</span> -->
            </el-card>
            <div
              v-show="this.form.inputs.length < 5"
              style="
                cursor: pointer;
                border: dashed 1px #999;
                padding: 10px;
                line-height: 30px;
                text-align: center;
              "
              @click="appendInputs"
            >
              +
            </div>
          </el-col>
          <!-- 第三列：用工 -->
          <el-col :span="7">
            <el-divider>用工和指导</el-divider>
            <el-row :gutter="10">
              <el-col :span="14">
                <el-form-item label="负责人">
                  <el-select v-model="form.leaderId">
                    <el-option
                      v-for="item in personsOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="参与人数">
                  <el-input-number
                    v-model="form.personCount"
                    :min="1"
                    style="width: 106px"
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="`用时（${form.hours}小时）`">
                  <div class="block">
                    <el-slider v-model="form.hours" :min="1" :max="10">
                    </el-slider>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="生产指导要求">
              <el-input
                type="textarea"
                v-model="form.memo"
                :rows="4"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-show="form.id&&this.form.date>new Date()" @click="remoke" type="warning">撤销</el-button>
              <el-button v-show="form.id&&this.form.date>new Date()" @click="updateSubmit" type="primary">保存</el-button>
              <el-button v-show="!form.id&&this.form.date>new Date()" type="primary" @click="workSubmit">
                保存
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { getInputs } from '@/api/inputs.js'
import { personSearch } from '@/api/person.js'
import { taskAdd, taskDateGet, taskDelete, inputsData,taskUpdate,InputListOfReserve} from '@/api/plan-list.js'
export default {
  props: {
    landId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      /**
       * 工人选项
       */
      personsOptions: [],
      /**
       * 投入品选项
       */
      inputsOptions: [],
      /**
       * 专家建议
       */
      suggest: undefined,
      /**
       * 生产活动日期
       */
      date: undefined,
      maxNum:0,
      /**
       * 表单
       */
      form: {
        id: undefined,
        date: undefined,
        hours: 1,
        inputs: [],
        landId: undefined,
        leaderId: undefined,
        personCount: 1,
        memo: '',
      },
    }
  },
  filters: {
    inputsName(id) {
      return '投入品名称'
    },
    week(val) {
      switch (val) {
        case 0:
          return '星期日'
        case 1:
          return '星期一'
        case 2:
          return '星期二'
        case 3:
          return '星期三'
        case 4:
          return '星期四'
        case 5:
          return '星期五'
        case 6:
          return '星期六'
      }
    },
    inputsPackForm(id) {
      return '包'
    },
  },
  mounted() {
    this.form.landId = this.landId
    InputListOfReserve(this.$store.getters.currentEnterprise.id).then((resp) => {
      this.inputsOptions = resp.data
    })
    personSearch(this.$store.getters.currentEnterprise.id, {
      pageNum: 1,
      pageSize: 0,
    }).then((resp) => {
      this.personsOptions = resp.data.list
    })
  },
  methods: {
    isDisabled(id) {
      let flag=this.form.inputs.find(item=>item.id==id);
      if(flag){
        return true
      }else{
        return false
      }
    },
    getMaxNum(id,inputsForm,i) {
      if(!id){
        return null
      }

      let arr=inputsForm.filter(item=>id==item.id)
      let num=0;
      arr.forEach(item=>{
        num+=item.volumn
      })
      let arr2=this.inputsOptions.find(item=>item.id==id)
      console.log(arr,num,arr2)
      console.log(this.form)
      this.form.inputs[i].packingForm=arr2.packingForm
      console.log("包装形式",this.form.inputs[i].packingForm,arr2.packagingForm)
      this.form.inputs[i].maxNum= arr2.remainNum-num
    },
    updateSubmit() {
      taskUpdate(this.form.id,this.form).then((data) => {
        this.back()
      })
    },
    inputsDelete(i) {
      this.form.inputs.splice(i, 1)
    },
    /**
     * 设置日期，供父组件调用
     */
    setDate(val) {
      this.date = val
      this.form.date = val.valueOf()
      taskDateGet(this.landId, val.valueOf()).then((resp) => {
        if (resp.data) {
          Object.keys(resp.data).forEach((item) => {
            this.form[item] = resp.data[item]
          })
          inputsData(this.form.id).then(data=>{
            console.log(data)
            this.form.inputs=data.data
            this.form.inputs.forEach((item,i)=>{
              let obj=this.inputsOptions.find((ite)=>ite.id==item.id)
              this.form.inputs[i].packagingForm=obj.packagingForm
              if(!obj){
                item.maxNum=item.volumn
                this.inputsOptions.push(item)
              }else{
                item.maxNum=item.volumn+obj.remainNum
              }

            })
          })
        }
      })
    },
    /**
     * 设置建议（如果有的话），供父组件调用
     */
    setSuggest(val) {
      this.suggest = val
    },
    appendInputs() {
      this.form.inputs.push({
        id: undefined,
        volumn: 0,
        packagingForm:''
      })
    },
    remoke() {
      taskDelete(this.form.id).then((data) => {
        this.back()
      })
    },
    workSubmit() {
      taskAdd(this.form).then((data) => {
        this.back()
      })
    },
    back() {
      this.$emit('quit')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/product/plan/PlanDetailWork.vue